import { __extends } from "tslib";
import { deserializeAws_restJson1_1UpdateEmailTemplateCommand, serializeAws_restJson1_1UpdateEmailTemplateCommand } from "../protocols/Aws_restJson1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var UpdateEmailTemplateCommand = /** @class */ (function (_super) {
    __extends(UpdateEmailTemplateCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UpdateEmailTemplateCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    UpdateEmailTemplateCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdateEmailTemplateCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1_1UpdateEmailTemplateCommand(input, context);
    };
    UpdateEmailTemplateCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1_1UpdateEmailTemplateCommand(output, context);
    };
    return UpdateEmailTemplateCommand;
}($Command));
export { UpdateEmailTemplateCommand };
//# sourceMappingURL=UpdateEmailTemplateCommand.js.map